import React, { useRef, useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';
import { Modal, Container, Row, Col, Table, Button } from 'react-bootstrap';
import { GoKebabVertical } from 'react-icons/go';
import { BsFillFileBarGraphFill } from 'react-icons/bs';
import ENDPOINT from '../../context/EndPoint';
import Checkbox from '@mui/material/Checkbox';
import UploadFile from '@mui/icons-material/UploadFile';
import { Link } from 'react-router-dom';
import SecurityHeaders from '../../context/SecurityHeaders';
import { Delete } from '@material-ui/icons';
import UploadImage from './UploadImage'; // Component for uploading new images
import DeleteModal from '../../components/modals/DeleteModal';
import { useDispatch } from 'react-redux';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useActionsContext } from '../../context/ActionsContext';
const AdminGetImages = ({ page, role }) => {
  const dispatch = useDispatch()
  const { user } = useContext(AuthContext);

  const [edit, setEdit] = useState(false);
  const [uploadImage, setUploadImage] = useState(false);
  const [images, setImages] = useState(null);
  const { rowsPerPage } = useActionsContext(); 
  

  const taskType = useRef();


  const getImages = async () => {
    dispatch({ type: 'LOADING' });
  
    const formData = new FormData();
    formData.append('session', user.SessionId);
    formData.append("limit" ,rowsPerPage);
  
    try {
      const res = await axios.post(
        ENDPOINT +'admin-get-images.php',
        formData,
        {
          headers: { 'content-type': 'multipart/form-data' },
        }
      );
  
      if (res?.data) {
        if (res.data.status === "success") { // Assuming there's a status field
          dispatch({ type: 'DONE_LOADING' });
          setImages(res.data.data);
        } else {
          dispatch({ 
            type: 'ERROR', 
            payload: res.data.message || 'Failed to fetch images' 
          });
        }
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: 'Invalid response format' 
        });
      }
    } catch (error) {
      dispatch({ 
        type: 'ERROR', 
        payload: error.message || 'An error occurred while fetching images' 
      });
    }
  };

  useEffect(() => {
    getImages();
  }, [rowsPerPage]);

  const deleteImage = async ({ id }) => {
    dispatch({ type: 'LOADING' });
  
    const formData = new FormData();
    formData.append('session', user.SessionId);
    formData.append('id', id);
  
    try {
      const res = await axios.post(
        ENDPOINT + 'admin-delete-image.php',
        formData,
        SecurityHeaders
      );
  
      if (res?.data) {
        if (res.data.status === 'success') {
          dispatch({ type: 'DONE_LOADING' });
          setinitiatedelete(false);
          getImages(); // Refresh the list after deletion, assuming this is the previously defined function
        } else {
          dispatch({ 
            type: 'ERROR', 
            payload: res.data.message || 'Failed to delete image' 
          });
        }
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: 'Invalid response format' 
        });
      }
    } catch (error) {
      dispatch({ 
        type: 'ERROR', 
        payload: error.message || 'An error occurred while deleting image' 
      });
    }
  };

  const [initiatedelete,setinitiatedelete] = useState(false)
  const [deleteid,setdeleteid] = useState(null)

  const groupBypage = (images) => {
    const groups = {};
    images?.forEach((img) => {
      if (!groups[img.page]) groups[img.page] = [];
      groups[img.page].push(img);
    });
    return groups;
  };
  
  const onDragEnd = async (result) => {
    const { source, destination } = result;
  
    if (!destination) return;
    const sourcepage = source.droppableId;
    const destpage = destination.droppableId;
  
    if (sourcepage !== destpage) return;
  
    const grouped = groupBypage(images);
    const pageImages = [...grouped[sourcepage]];
    const [movedImage] = pageImages.splice(source.index, 1);
    pageImages.splice(destination.index, 0, movedImage);
  
    // Update positions only for this page
    const updatedImages = images.map((img) => {
      if (img.page !== sourcepage) return img;
  
      const reordered = [...pageImages];
      const updated = reordered.find((i) => i.id === img.id);
      if (updated) {
        return { ...updated, position: reordered.indexOf(updated) + 1 };
      }
      return img;
    });
  
    setImages(updatedImages);
  
    const formData = new FormData();
    formData.append('session', user.SessionId);
    formData.append('page', sourcepage);
    formData.append('images', JSON.stringify(pageImages.map((img, i) => ({
      id: img.id,
      position: i + 1,
    }))));
  
    try {
      const res = await axios.post(
        ENDPOINT +'admin-update-image-order.php',
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
  
      if (res.data.status === 'success') getImages();
    } catch (error) {
      console.error('Reorder failed:', error);
      getImages(); // fallback
    }
  };
  return (
    <>
 <div className="container-fluid pt-4">
 <DeleteModal show={initiatedelete} HandleDelete={()=>deleteImage({id:deleteid})} HandleClose={()=>setinitiatedelete(false)}/>
     
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>Gallery Images</h2>
          <Link className='btn btn-primary' to="/upload-image" variant="primary" onClick={() => setUploadImage(true)}>
            Add New Image
          </Link>
        </div>

        <DragDropContext onDragEnd={onDragEnd}>
  {Object.entries(groupBypage(images)).map(([page, catImages]) => (
    <div key={page} className="mb-5">
      <h5 className="mb-3">{page.toUpperCase()}</h5>
      <Table bordered hover>
        <thead>
          <tr>
            <th>Image</th>
            <th>Title</th>
            <th>page</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <Droppable droppableId={page}>
          {(provided) => (
            <tbody ref={provided.innerRef} {...provided.droppableProps}>
              {catImages.map((image, index) => (
                <Draggable key={image.id.toString()} draggableId={image.id.toString()} index={index}>
                  {(provided) => (
                    <tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                      <td className="col-2">
                        <img className="image img-fluid" src={image.image_url} alt={image.title} />
                      </td>
                      <td>{image.title}</td>
                      <td>{image.page}</td>
                      <td>Active</td>
                      <td>
                        <Delete onClick={() => {
                          setdeleteid(image.id);
                          setinitiatedelete(true);
                        }} />
                      </td>
                    </tr>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </tbody>
          )}
        </Droppable>
      </Table>
    </div>
  ))}
</DragDropContext>

      </div>

     
    </>
  );
};

export default AdminGetImages;
